import EmailIcon from 'public/assets/social/icon-email.svg'

import encode from '../encodeForShare'

import css from './EmailShareButton.module.css'

export type EmailShareButtonProps = {
    title: string
    url: string
}

export default function EmailShareButton({ title, url }: EmailShareButtonProps) {
    const emailShareLink = 'mailto:?' + `subject=${encode(title)}&` + `body=${encode(url)}`

    return (
        <a href={emailShareLink}>
            <EmailIcon className={css.iconEmail} />
        </a>
    )
}
